import * as React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useXyqarAuth } from '@xyqar/shared-auth';
import { useSessionManager } from '../hooks/useSessionManager';
import { AUTH_RETURN_TO_KEY } from '../authReturnTo';

export default function RootLayout() {
  useSessionManager();
  const { loading, principal } = useXyqarAuth();
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    if (loading || !principal) return;
    const returnTo = sessionStorage.getItem(AUTH_RETURN_TO_KEY);
    if (!returnTo) return;
    // Skip if already on the target path (avoids redirect loop)
    if (location.pathname === returnTo || location.pathname.startsWith(returnTo + '/')) return;
    sessionStorage.removeItem(AUTH_RETURN_TO_KEY);
    navigate(returnTo, { replace: true });
  }, [loading, principal, location.pathname, navigate]);

  return <Outlet />;
}
